import React, { createContext, useContext, useMemo, useState } from 'react';

interface ILoadingContext {
  isLoading: boolean;
  setIsLoading: React.Dispatch<React.SetStateAction<boolean>>;
}

const LoadingContext = createContext<ILoadingContext | undefined>(undefined);

export const useLoading = (): ILoadingContext => {
  const context = useContext(LoadingContext);
  if (!context) {
    throw new Error('useLoading must be used within a LoadingProvider');
  }
  return context;
};

export const LoadingProvider = ({ children }: { children: React.ReactNode }) => {
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const loaderContextValue = useMemo(() => ({ isLoading, setIsLoading }), [isLoading]);
  return <LoadingContext.Provider value={loaderContextValue}>{children}</LoadingContext.Provider>;
};
